<template>
  <li
    :class="[
      'tag-color',
      'tag-color--' + color,
      {
        small: size === 'small',
        normal: size === 'normal',
        large: size === 'large',
      },
    ]"
  >
    <slot />
  </li>
</template>
<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: 'grey',
  },
  removable: {
    type: Boolean,
    default: true,
  },
  size: {
    type: String,
    default: 'normal',
    validator: (size: string) => ['small', 'normal', 'large'].includes(size),
  },
});
</script>
<style lang="postcss" scoped>
li {
  @apply cursor-default flex items-center w-max text-xs rounded relative py-1 px-3.5 transition-all whitespace-nowrap;
}

.small {
  @apply py-[.1rem] px-[.5rem];
}

.normal {
  /* default */
  @apply py-1 px-3.5;
}

.tag-color {
  &--grey {
    @apply bg-neutral-500 text-white border border-neutral-500;
  }

  &--white {
    @apply bg-white text-neutral-500 border border-neutral-500;
  }

  &--light-grey {
    @apply bg-dark-100 text-dark-750;
  }

  &--blackish {
    @apply bg-dark-500 text-light-100;
  }

  &--reddish {
    @apply bg-error-600 text-light-100;
  }

  &--apiColor {
    @apply bg-[var(--main-color)] text-light-100;
  }

  &--transparent-white {
    @apply bg-dark-200;

    color: rgb(255 255 255 / 95%);
  }

  &--transparent {
    @apply border border-white text-white;
  }

  &--transparent-grey {
    @apply border border-neutral-500 text-neutral-500;
  }
}
</style>
